module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/CoverSection/third-party-8794d9c7af96cf75d6b8691dc1944213.png";